<!-- Header footer section start -->
<section id="header-footer">
    <div class="row">
        <div class="col-12 mb-1">
            <div class="content-header" [innerHTML]="collection_data?.title | highlightText"></div>
            <p class="content-sub-header mb-1" [innerHtml]="collection_data?.description | highlightText"></p>
        </div>
    </div>
    <div class="row">
        <div class="col-11">
            <span class="badge badge-pill badge-primary mb-1 mr-2" *ngFor='let t of this.collection_data?.tags'
                (click)='selectTag(t)'>{{t.displayname}}</span>
        </div>
        <div class="col-1"> <span class="badge badge-pill badge-primary mb-1 mr-2" (click)="back()">Back</span></div>
    </div>

    <div class="row match-height" *ngIf='collection_data?.content'>
        <div class="col-lg-12 col-md-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <p class="card-text"
                            [innerHtml]="collection_data?.content | highlightText: searchTerm | highlightText: searchTerm | markdown ">
                        </p>
                    </div>
                </div>
                <div class="card-footer text-muted pt-0">
                    <span class="float-right">
                        <span class="badge badge-pill badge-primary mb-1 mr-2"> <a style="color: #fff;"
                                href="javascript:void(Tawk_API.toggle())"><img src="assets/img/live-helpicon.png">Live
                                Help</a></span>
                        <span class="badge badge-pill badge-primary mb-1 mr-2"
                            (click)='copyToClipboard(collection_data?.content )'>Copy</span>
                    </span>
                </div>
            </div>
        </div>
    </div>

</section>